import CustomReasonInput from '@molecules/CustomReasonInput';
import React from 'react';

export default function shouldShowCustomReasons(
  isEditReasons: boolean,
  setCustomReasonText: (text: string) => void,
  source: string,
): React.ReactElement | null {
  if (!isEditReasons) {
    return <CustomReasonInput setCustomReasonText={setCustomReasonText} source={source} />;
  }
  return null;
}
